import { DOTS, usePagination } from "./usePagination";
import classnames from "classnames";
import styles from "./Pagination.module.scss";
import { Show } from "../Util/Show";
import { Each } from "../Util/Each";
import React from "react";
import pijlNav from "../../assets/images/pijlNav.svg";

export function Pagination({
  onPageChange,
  totalCount,
  siblingCount = 2,
  currentPage,
  pageSize,
  className,
  pluginUrl,
}) {
  const paginationRange = usePagination({
    currentPage,
    totalCount,
    siblingCount,
    pageSize,
  });

  const arrowImage = pluginUrl + pijlNav;

  if (totalCount === 0) {
    return null;
  }

  const onNext = () => {
    onPageChange(currentPage + 1);
  };

  const onPrevious = () => {
    onPageChange(currentPage - 1);
  };

  let lastPage = paginationRange[paginationRange.length - 1];
  let firstPage = paginationRange[0];

  function dotsOrPage(pageNumber, index) {
    if (pageNumber === DOTS) {
      return (
        <li
          className={`${styles["pagination-item"]} ${styles["dots"]}`}
          key={index}
        >
          &#8230;
        </li>
      );
    }
    return (
      <li
        className={classnames(styles["pagination-item"], {
          [styles.selected]: pageNumber === currentPage,
        })}
        onClick={() => onPageChange(pageNumber)}
        key={index}
      >
        {pageNumber}
      </li>
    );
  }

  return (
    <ul className={classnames(styles["pagination-container"], className)}>
      {/* Left navigation arrow */}

      <li
        className={classnames(styles["pagination-item"], {
          [styles.disabled]: currentPage === 1,
        })}
        onClick={onPrevious}
      >
        <Show>
          <Show.When isTrue={currentPage !== firstPage}>
            <img
              src={arrowImage}
              style={{ width: "20px", rotate: "180deg" }}
              alt={"Arrow"}
            />
          </Show.When>
        </Show>
      </li>

      <Each of={paginationRange} render={dotsOrPage} />
      <li
        className={classnames(styles["pagination-item"], {
          [styles.disabled]: currentPage === lastPage,
        })}
        onClick={onNext}
      >
        <Show>
          <Show.When isTrue={currentPage !== lastPage}>
            <img src={arrowImage} style={{ width: "20px" }} alt={"Arrow"} />
          </Show.When>
        </Show>
      </li>
      {/*  Right Navigation arrow */}
    </ul>
  );
}
